import { track, EventTypes } from '@mc/track-event'

export const trackCertificatesRowClick = () =>
  track(EventTypes.PLANS_PAGE_CLICK, {
    category: 'pricing matrix',
    action: 'certificates.tooltip',
    location: 'General',
  })
